import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5154d5dd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "stats-overlay-container" };
const _hoisted_2 = {
    key: 0,
    class: "full-parent grid-center absolute umbra"
};
const _hoisted_3 = {
    key: 0,
    id: "stats-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadingIndicator = _resolveComponent("LoadingIndicator");
    const _component_StatsNumerical = _resolveComponent("StatsNumerical");
    const _component_StdBarChart = _resolveComponent("StdBarChart");
    const _component_StdLineChart = _resolveComponent("StdLineChart");
    const _component_StdDoughnutChart = _resolveComponent("StdDoughnutChart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "load" }, {
            default: _withCtx(() => [
                (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_LoadingIndicator)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        }),
        _createVNode(_Transition, { name: "stats" }, {
            default: _withCtx(() => [
                (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_StatsNumerical, {
                            title: "Flight Time (in h)",
                            average: _ctx.flightTime.average,
                            median: _ctx.flightTime.median,
                            deviation: _ctx.flightTime.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Violation 1",
                            average: _ctx.violation1.average,
                            median: _ctx.violation1.median,
                            deviation: _ctx.violation1.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Landings",
                            average: _ctx.landings.average,
                            median: _ctx.landings.median,
                            deviation: _ctx.landings.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Violation 2",
                            average: _ctx.violation2.average,
                            median: _ctx.violation2.median,
                            deviation: _ctx.violation2.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Experience",
                            average: _ctx.experience.average,
                            median: _ctx.experience.median,
                            deviation: _ctx.experience.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Violation 3",
                            average: _ctx.violation3.average,
                            median: _ctx.violation3.median,
                            deviation: _ctx.violation3.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "ATC Ops",
                            average: _ctx.atcOps.average,
                            median: _ctx.atcOps.median,
                            deviation: _ctx.atcOps.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StatsNumerical, {
                            title: "Σ Violations",
                            average: _ctx.violationTotal.average,
                            median: _ctx.violationTotal.median,
                            deviation: _ctx.violationTotal.deviation
                        }, null, 8, ["average", "median", "deviation"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Departure Airports",
                            data: _ctx.topDepartures
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Arrival Airports",
                            data: _ctx.topArrivals
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdLineChart, {
                            class: "chart",
                            title: "T < 48h - Pilot Count",
                            data: _ctx.serverLoad
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdDoughnutChart, {
                            class: "chart",
                            title: "Top 10 - Aircraft Type",
                            data: _ctx.topAircraftType
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Busiest Airports (Arrivals + Departures)",
                            data: _ctx.topBusiests
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdDoughnutChart, {
                            class: "chart",
                            title: "Top 10 - Aircraft",
                            data: _ctx.topAircraft
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - XP",
                            data: _ctx.topXP
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdDoughnutChart, {
                            class: "chart",
                            title: "Grade Distribution",
                            data: _ctx.gradeDistribution
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Flight Time (in h)",
                            data: _ctx.topFlightTimes
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - ATC Ops",
                            data: _ctx.topAtcOps
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Landing Count",
                            data: _ctx.topLandings
                        }, null, 8, ["data"]),
                        _createVNode(_component_StdBarChart, {
                            class: "chart",
                            title: "Top 10 - Speed (in kn)",
                            data: _ctx.topSpeeds
                        }, null, 8, ["data"])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        })
    ]));
}
